import { NgModule } from '@angular/core';
import { ButtonComponent } from './button/button.component';
import { CommonModule } from '@angular/common';
import { PanelComponent } from './panel/panel.component';
import { CompareSectionComponent } from './compare-section/compare-section.component';
import { AlternativeTransferComponent } from './alternative-transfer/alternative-transfer.component';
import { StepComponent } from './step/step.component';
import { InputComponent } from './input/input.component';
import { DirectivesModule } from '../../directives/directives.module';
import { IconComponent } from './icon/icon.component';
import { MatIconModule } from '@angular/material';
import { PipesModule } from '../../pipes';

const MATERIAL_MODULES = [MatIconModule];

const ELEMENTS = [
  ButtonComponent,
  PanelComponent,
  CompareSectionComponent,
  AlternativeTransferComponent,
  StepComponent,
  InputComponent,
  IconComponent,
];

@NgModule({
  imports: [...MATERIAL_MODULES, CommonModule, DirectivesModule, PipesModule],
  declarations: [...ELEMENTS],
  exports: [...ELEMENTS],
})
export class AtomsModule {}
